import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  AppBar,
  Toolbar,
  IconButton,
  Typography,
  Box,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from "@mui/material";
import ArrowForwardIcon from "@mui/icons-material/ArrowBack";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore"; // Icono para expandir el acordeón

const Informate = () => {
  const [expanded, setExpanded] = useState(false);
  const [expandedInternal, setExpandedInternal] = useState(null); // State for internal accordions
  const navigate = useNavigate();

  const handleChange = (panel) => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : false);
  };

  const handleInternalAccordionChange = (panel) => (event, newExpanded) => {
    setExpandedInternal(newExpanded ? panel : null); // Set state for internal accordion
  };

  return (
    <div style={{ minHeight: "100vh", backgroundColor: "#f7f7f7" }}>
      {/* AppBar */}
      <AppBar position="sticky" style={{ backgroundColor: "#59005B" }}>
        <Toolbar>
          <IconButton edge="start" color="inherit" onClick={() => navigate(-1)}>
            <ArrowForwardIcon />
          </IconButton>
          <Typography
            variant="h6"
            sx={{
              flexGrow: 1,
              fontFamily: "'Poppin', 'Helvetica', 'Arial', sans-serif",
              letterSpacing: 4,
            }}
          >
            INFÓRMATE
          </Typography>
        </Toolbar>
      </AppBar>

      {/* Contenido principal */}
      <div
        style={{
          padding: "20px",
          paddingBottom: "80px",
          backgroundColor: "#f7f7f7",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            textAlign: "left",
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              textAlign: "center",
            }}
          >
            <img
              src={`${process.env.PUBLIC_URL}/assets/images/BannerFYI.png`}
              alt="Icono Nos Apoyan"
              style={{
                width: "90%",
                height: "auto",
                marginBottom: "32px",
              }}
            />
          </Box>

          {/* Acordeón de información */}
          <Accordion
            expanded={expanded === "panel1"}
            onChange={handleChange("panel1")}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1-content"
              id="panel1-header"
            >
              <Typography variant="h6" style={{ color: "#6a4c9c" }}>
                ¿Debes pagar por los servicios de atención que brindan las
                instituciones públicas?
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography variant="body1" style={{ color: "#6a4c9c" }}>
                Los servicios de atención en salud, deben ser brindados de forma
                gratuita. (art. 26 letra a de la Ley de Igualdad, Equidad y
                Erradicación de la Discriminación contra las Mujeres-LIE y Art.
                66 de la Constitución de la República.
                <br /> <br />
                El acceso a la Justicia, debe ser gratuita, según el artículo
                181 de la Constitución de la República. <br /> <br />
                La Procuraduría General de la República-PGR, brinda servicios de
                asistencia legal gratuitos, en (art. 194 romano II ordinal 2do
                de la Constitución de la República, Ley Orgánica de la
                Procuraduría General de la Republica, relacionados con el art.
                6, letra a) de la ley de Ética Gubernamental.
              </Typography>
            </AccordionDetails>
          </Accordion>

          <Accordion
            expanded={expanded === "panel2"}
            onChange={handleChange("panel2")}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel2-content"
              id="panel2-header"
            >
              <Typography variant="h6" style={{ color: "#6a4c9c" }}>
                ¿Pueden negarme servicios en razón de mi religión o creencias?
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography variant="body1" style={{ color: "#6a4c9c" }}>
                Las personas servidoras públicas no pueden denegarte la
                prestación de un servicio público al que tengas derecho, en
                razón de tu nacionalidad, raza, sexo, religión, opinión
                política, condición social o económica, discapacidad o cualquier
                otra razón injustificada (Art. 6, letra “j” de la Ley de Ética
                Gubernamental).
              </Typography>
            </AccordionDetails>
          </Accordion>

          <Accordion
            expanded={expanded === "panel3"}
            onChange={handleChange("panel3")}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel3-content"
              id="panel3-header"
            >
              <Typography variant="h6" style={{ color: "#6a4c9c" }}>
                ¿Qué puedes hacer si no te atienden?
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography variant="body1" style={{ color: "#6a4c9c" }}>
                Todas las instituciones públicas, como PNC, PGR y MINSAL, tienen
                la obligación legal de atenderte en casos de violencia contra
                las mujeres, en caso que no lo hagan, o no estés satisfecha con
                los servicios, puedes acudir a las siguientes instituciones para
                recibir asesoría completamente gratuita sobre qué hacer:
                <br /> <br />
              </Typography>

              {/* Sub acordeón */}
              <Accordion
                expanded={expandedInternal === "subPanel1"}
                onChange={handleInternalAccordionChange("subPanel1")}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="subPanel1-content"
                  id="subPanel1-header"
                >
                  <Typography variant="subtitle2" style={{ color: "#6a4c9c" }}>
                    Procuraduría para la Defensa de los Derechos Humanos (PDDH).
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography variant="body2" style={{ color: "#6a4c9c" }}>
                    Puedes poner una denuncia que tramitará la institución.{" "}
                    <br />
                    <br />
                    Es requisito que te hayan negado el servicio e identificarte
                    con Documento Único de Identidad.
                    <ul>
                      <li>Consultas al Teléfono: 25204300</li>
                      <li>Denuncias al Teléfono: 25204331</li>
                      <li>
                        Dirección: 5ta. Ave. Nte., y 19 Calle Pte. No. 12,
                        Centro de Gobierno, San Salvador
                      </li>
                    </ul>
                  </Typography>
                </AccordionDetails>
              </Accordion>
              <Accordion
                expanded={expandedInternal === "subPanel2"}
                onChange={handleInternalAccordionChange("subPanel2")}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="subPanel2-content"
                  id="subPanel2-header"
                >
                  <Typography variant="subtitle2" style={{ color: "#6a4c9c" }}>
                    Tribunal de Ética Gubernamental.
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography variant="body2" style={{ color: "#6a4c9c" }}>
                    Puedes poner una denuncia que tramitara la institución, como
                    requisito es necesario que te hayan negado el servicio e
                    identificarte con Documento Único de Identidad.
                    <br /> <br />
                    Página Web:{" "}
                    <a
                      href="https://teg.gob.sv/denuncias/#.XaXFX0YzbIU"
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{ textDecoration: "none", color: "inherit" }}
                    >
                      https://teg.gob.sv/denuncias/#.XaXFX0YzbIU
                    </a>
                    <br /> <br />
                    <b>CONTACTOS EN SEDE CENTRAL:</b> <br />
                    Lic. William Rivera; willian.rivera@teg.gob.sv, <br />
                    Lic. David Cruz; d.cruz@teg.gob.sv. <br />
                    Teléfono: 2565-9436 y 2565-9438. <br /> <br />
                    <b>CONTACTO EN SEDE EN SAN MIGUEL:</b> <br />
                    Licda. Roxana Sánchez; r.sanchez@teg.gob.sv. <br />
                    Teléfono: 2605-1424.
                  </Typography>
                </AccordionDetails>
              </Accordion>
              {/* <Accordion
                expanded={expandedInternal === "subPanel3"}
                onChange={handleInternalAccordionChange("subPanel3")}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="subPanel3-content"
                  id="subPanel3-header"
                >
                  <Typography variant="subtitle2" style={{ color: "#6a4c9c" }}>
                    Fundación Nacional para el Desarrollo.
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography variant="body2" style={{ color: "#6a4c9c" }}>
                    Página web:{" "}
                    <a
                      href="http://alac.funde.org/start"
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{ textDecoration: "none", color: "inherit" }}
                    >
                      http://alac.funde.org/start
                    </a>
                    <br /> <br />
                    <b>CENTRO DE ASESORÍA LEGAL ANTICORRUPCIÓN.</b> <br />
                    Teléfonos: 2209-5324, 7987-1688. <br />
                    Correo electrónico: alac@funde.org. <br />
                    Dirección: Calle Arturo Ambrogi No. 411, Col. Escalón. San
                    Salvador, El Salvador, C.A.
                  </Typography>
                </AccordionDetails>
              </Accordion> */}
              <Accordion
                expanded={expandedInternal === "subPanel4"}
                onChange={handleInternalAccordionChange("subPanel4")}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="subPanel4-content"
                  id="subPanel4-header"
                >
                  <Typography variant="subtitle2" style={{ color: "#6a4c9c" }}>
                    Procuraduría General de la República (PGR).
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography variant="body2" style={{ color: "#6a4c9c" }}>
                    La PGR a través de la Unidad de Atención Especializada para
                    Mujeres, tiene como mandato brindar servicios de asistencia
                    legal, psicológica y social a mujeres que enfrentan hechos
                    de violencia intrafamiliar, de género o discriminación.
                    <br />
                    <br />
                    Los servicios son totalmente gratuitos y si existiere algún
                    cobro, puedes reportarlo al siguiente número de whatsapp:
                    76079013.
                  </Typography>
                </AccordionDetails>
              </Accordion>
            </AccordionDetails>
          </Accordion>
          
        </Box>
      </div>
    </div>
  );
};

export default Informate;
